import React from 'react';

/**
 * Centralized Tailwind CSS classes for navigation components
 */

// Base color classes
export const BASE_TEXT_COLOR = 'text-zinc-700 dark:text-white';
export const BASE_CONTAINER_COLOR = 'text-zinc-700';

// Hover states
export const NAV_ITEM_HOVER = 'hover:bg-zinc-300 dark:hover:bg-dark-background';
export const LOGOUT_HOVER = 'hover:bg-zinc-300 dark:hover:bg-dark-background';

// Borders and spacing
export const NAV_ITEM_BORDER = 'border-solid border-0 rounded-md m-1';
export const DIVIDER_BORDER = 'border-t border-zinc-300 my-2';

// Font weights
export const FONT_PRIMARY = 'font-primary';

// Common button styling
export const BUTTON_BASE = `hover:cursor-pointer ${NAV_ITEM_BORDER} ${LOGOUT_HOVER} text-red-600 dark:text-red-500`;

// Mobile navigation overlay
export const MOBILE_OVERLAY = 'fixed inset-0 bg-black bg-opacity-55 z-[98]';

// Hamburger menu button
export const HAMBURGER_BUTTON = 'z-[101] lg:hidden fixed top-1.5 sm:top-2 left-2 border-0 flex items-center justify-center';

// Icon margin and shrink
export const ICON_BASE = 'mr-1 flex-shrink-0';

// Text positioning
export const TEXT_LEFT_GROW = 'flex-grow text-left';

// Sidebar base classes (without responsive parts)
export const SIDEBAR_BASE = 'z-[99] fixed bg-backgroundNav dark:!bg-dark-backgroundNav flex flex-col w-64 px-2 h-screen max-h-screen overflow-y-scroll transition duration-300 border-r border-zinc-300 dark:border-zinc-600';

// Sidebar responsive classes
export const SIDEBAR_RESPONSIVE = 'lg:translate-x-0';

// Font weight variations
export const FONT_MEDIUM = 'font-medium';
export const FONT_SEMIBOLD = 'font-semibold';

// Text size variations for different screen states
export const TEXT_SIZE_OVERFLOW = 'text-xs';
export const TEXT_SIZE_LARGE = 'text-base lg:text-lg';
export const TEXT_SIZE_MEDIUM = 'text-sm md:text-base';

// Icon size variations for different screen states
export const ICON_SIZE_OVERFLOW = 'h-3 w-3';
export const ICON_SIZE_LARGE = 'h-5 w-5 lg:h-6 lg:w-6';
export const ICON_SIZE_MEDIUM = 'h-4 w-4 md:h-5 md:w-5';

// Combined responsive text sizes
export const RESPONSIVE_TEXT_SIZES = {
  overflow: TEXT_SIZE_OVERFLOW,
  large: TEXT_SIZE_LARGE,
  medium: TEXT_SIZE_MEDIUM,
} as const;

// Combined responsive icon sizes (without margin/shrink)
export const RESPONSIVE_ICON_SIZES = {
  overflow: ICON_SIZE_OVERFLOW,
  large: ICON_SIZE_LARGE,
  medium: ICON_SIZE_MEDIUM,
} as const;

// Link base classes
export const LINK_BASE = `${BASE_TEXT_COLOR} flex items-center justify-start p-2 space-x-2 transition-colors duration-200 ease-out`;

// Width style for expanded navigation
export const EXPANDED_WIDTH: React.CSSProperties = { width: '100%' };

// Text display style for collapsed navigation
export const COLLAPSED_DISPLAY: React.CSSProperties = { display: 'block' };

// Border radius for collapsed navigation
export const COLLAPSED_RADIUS: React.CSSProperties = { borderRadius: '0%' };

// Padding variations
export const PADDING_OVERFLOW = 'py-2';
export const PADDING_NORMAL = 'py-4';

// Mobile bottom padding
export const MOBILE_BOTTOM_PADDING = 'w-full h-0';
